var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.76086 9.07163L0.0934517 1.40421C-0.033217 1.27085 -0.0299042 1.06083 0.100109 0.934159C0.230121 0.810803 0.433485 0.810803 0.563498 0.934159L7.99423 8.3649L15.4283 0.934159C15.555 0.800802 15.7683 0.797489 15.8984 0.927502C16.0317 1.05417 16.035 1.26754 15.905 1.39755C15.9017 1.40089 15.8984 1.40421 15.8984 1.40421L8.23094 9.07163C8.1009 9.20164 7.89088 9.20164 7.76086 9.07163Z","fill":"#7B7979"}));
}

ChevronDown.defaultProps = {"width":"16","height":"10","viewBox":"0 0 16 10","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
